import { Pipe, PipeTransform } from '@angular/core';
import { MissionNoticeDto } from '@flyfreely-portal-ui/flyfreely';

@Pipe({ name: 'noticeStatusClass', pure: true })
export class NoticeStatusClassPipe implements PipeTransform {
    transform(status: MissionNoticeDto.Status, isAcknowledged: boolean): string {
        if (isAcknowledged) {
            return 'active'
        }
        switch (status) {
            case MissionNoticeDto.Status.APPLICABLE:
                return 'pending';

            case MissionNoticeDto.Status.INFORMATIONAL:
                return 'disabled';

            case MissionNoticeDto.Status.BLOCK:
                return 'inactive';

            case MissionNoticeDto.Status.NOT_RELEVANT:
            default:
                return 'disabled';
        }
    }
}
